
import { ButtonGroup } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "../common/components/Grid";
import TimeInput from "../common/components/TimeInput";
import DateInput from "../common/components/DateInput";
import Button from "../common/components/Button";
import { useEpcrVitalDefs } from "../reducers/epcrVitalSlice";
import { useEffect, useMemo, useState } from "react";
import { dynamicSort } from "../common/utils/tableUtilities";
import Card from "../common/components/Card";
import CustomForm from "../common/components/CustomForm";
import { DefaultButton } from "../common/components/DefaultButton";
import { Modal } from "../common/utils/dialogUtlities";

const VitalCard = ({def, disabled, data, onChange}) => {
    return <Card title={def.type}>
        <CustomForm disabled={disabled} hideLabel={true} def={def.def} data={data} onChange={v => onChange('values', {[def.type]: v})}></CustomForm>
    </Card>
}

export const VitalsDialog = ({showDialog, onClose, onChange, onRemove, disabled, vital}) => {
    const { t } = useTranslation();
    const vitalDefs = useEpcrVitalDefs();
    const [timestamp, setTimestamp] = useState(vital?.timestamp);
    const [groupFilter, setGroupFilter] = useState(null);

    useEffect(() => setTimestamp(vital?.timestamp), [vital?.timestamp]);

    let groups = useMemo(() => {
        let groups = vitalDefs?.map(v => v.group)
        groups = groups.filter((g, i) => g && groups.indexOf(g) === i);
        groups.sort();
        return groups;
    }, [vitalDefs]);

    let filteredDefs = useMemo(() => {
        let filteredDefs = vitalDefs.filter(def => def.group === groupFilter);
        filteredDefs.sort(dynamicSort(['sequence','type']));
        return filteredDefs;
    }, [vitalDefs, groupFilter]);

    useEffect(() => {
        if (vitalDefs && !groupFilter) {
            setGroupFilter(groups[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vitalDefs])

    let handleClose = () => {
        setGroupFilter(groups[0]);
        onClose();
    }

    let handleRemove = () => {
        setGroupFilter(groups[0]);
        onRemove();
    }

    let timeDisabled = disabled || vital?.timestamp;

    let buttons = vitalDefs.every(v => v.group) ? <ButtonGroup className="d-flex justify-content-center">{groups.map(g => <Button key={g} variant={g === groupFilter ? 'primary' : 'default'} onClick={_ => setGroupFilter(g)}>{g}</Button>)}</ButtonGroup> : null

    return (
        <Modal show={showDialog} onHide={handleClose} size='xlg'>
            <Modal.Header closeButton>
                <Modal.Title>{t('vitalDetails')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3">
                    <Col md={timeDisabled ? 6 : 4}>
                        <TimeInput hideLabel={true} disabled={timeDisabled} value={timestamp} placeholder={t('timeOfDay')} required={true} onChange={setTimestamp}></TimeInput>
                    </Col>
                    <Col md={timeDisabled ? 6 : 4}>
                        <DateInput hideLabel={true} disabled={timeDisabled} value={timestamp} placeholder={t('dateTime')} required={true} onChange={setTimestamp}></DateInput>
                    </Col>
                    {!timeDisabled ? <Col md={4}>
                        <Button className="mt-2" variant="primary" hideLabel={true} disabled={!timestamp} onClick={_ => onChange('timestamp', timestamp)}>{t('setTime')}</Button>
                    </Col> : null}
                </Row>
                {vital?.id ? 
                <>{buttons} 
                <Container fluid>
                    {filteredDefs.map(def => <VitalCard key={def.type} def={def} disabled={disabled} onChange={onChange} data={vital.values[def.type]}></VitalCard>)}
                </Container>
                </>
                : null}
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col>
                        {!disabled ? <DefaultButton className='mr-2' disabled={!vital?.id} kind='delete' onClick={handleRemove}></DefaultButton> : null}
                        <DefaultButton kind='close' onClick={handleClose}></DefaultButton>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}